var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "invite-root",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: { "padding-top": `${_vm.barHeight}px` },
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.dl.agentCenter"))),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("div", [
                      _c("img", {
                        staticClass: "rules-icon",
                        attrs: {
                          src: require("./images/rules-tips1.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            if ($event.target !== $event.currentTarget)
                              return null
                            return _vm.handleToRules.apply(null, arguments)
                          },
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "policy-flag",
                          on: {
                            click: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "selt",
                                  undefined,
                                  $event.key,
                                  undefined
                                )
                              )
                                return null
                              return _vm.handleToPolicy.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.dl.policy")))]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { style: `min-height: ${_vm.barHeight + 46}px` }),
      _c("div", { staticClass: "invite-whole-bgc" }),
      _c("div", { staticClass: "invite-top-bg" }, [
        _c("div", { staticClass: "invite-bg-img" }, [
          _vm.packageName === "kiko"
            ? _c("img", {
                attrs: { src: require("./images/bg-kiko.png"), alt: "" },
              })
            : _c("img", {
                attrs: { src: require("./images/bg.png"), alt: "" },
              }),
        ]),
      ]),
      _vm.baseInfo
        ? _c("p", { staticClass: "earn-tips right-read" }, [
            _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k002")) + " "),
            _c("i", { staticClass: "earn-percent" }, [
              _vm._v(_vm._s(_vm.baseInfo.maxShareRate || "") + "%"),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k003")) + " "),
          ])
        : _vm._e(),
      _c("div", { staticClass: "invite-hostess" }, [
        _c(
          "div",
          { staticClass: "right-read", on: { click: _vm.handleInvite } },
          [_vm._v(_vm._s(_vm.$t("lang.newInvite.k001")))]
        ),
      ]),
      _vm.baseInfo
        ? _c(
            "div",
            {
              staticClass: "invite-code right-read",
              on: { click: _vm.handleCopyCode },
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("lang.dl.invitationCode")) + "： "),
              _c("i", { staticClass: "code-yellow right-read" }, [
                _vm._v(_vm._s(_vm.baseInfo.inviteCode || "")),
              ]),
              _c("img", { attrs: { src: require("./images/copy.png") } }),
            ]
          )
        : _vm._e(),
      _vm.baseInfo
        ? [
            _c("div", { staticClass: "invite-mybalance" }, [
              _c(
                "div",
                {
                  staticClass: "todayincome-title right-read",
                  on: { click: _vm.handleJumpInviteDetail },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("lang.mybean.totalIncome")) + " "),
                  _c("div", { staticClass: "income-beans" }, [
                    _c("img", {
                      staticClass: "beans-icon",
                      attrs: { src: _vm.getMatchImg("beans") },
                    }),
                    _vm._v(" " + _vm._s(_vm.baseInfo.agentSumBean) + " "),
                  ]),
                  _c("img", {
                    staticClass: "icon-arrow-r ar-arrow",
                    attrs: { src: require("./images/arrow-r.png") },
                  }),
                ]
              ),
              _c("div", { staticClass: "invite-mybalance-title right-read" }, [
                _vm._v(_vm._s(_vm.$t("lang.wd.myBalance"))),
              ]),
              _c("div", { staticClass: "withdraw-info right-read" }, [
                _c("div", { staticClass: "withdraw-info-beans" }, [
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                  _c("i", { staticClass: "beans-count" }, [
                    _vm._v(_vm._s(_vm.baseInfo.walletBean)),
                  ]),
                  _c("i", { staticClass: "beans-price" }, [
                    _vm._v(" ≈ "),
                    _c(
                      "i",
                      { staticStyle: { "font-family": "Inter-Regular" } },
                      [_vm._v(_vm._s(_vm.baseInfo.currencyCode))]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.numberTransformK(
                            _vm.baseInfo.currencyAmount / 100,
                            _vm.baseInfo.locationCode
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "withdraw-info-btn",
                    on: { click: _vm.handleWithdraw },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.withdraw")))]
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "switch-tab right-read",
                staticStyle: { position: "sticky", "z-index": "999" },
                style: `top: ${_vm.barHeight + 46}px;`,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: { "active-tab": _vm.tabIndex == _vm.tabEnmu.invite },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleSwitchTab(_vm.tabEnmu.invite)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.dl.invite")))]
                ),
                _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: {
                      "active-tab": _vm.tabIndex == _vm.tabEnmu.commission,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleSwitchTab(_vm.tabEnmu.commission)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("lang.dl.commission")) + " ")]
                ),
              ]
            ),
            _vm.tabIndex === _vm.tabEnmu.invite
              ? _c("InviteTab", {
                  attrs: { info: _vm.baseInfo },
                  on: {
                    "hook:mounted": _vm.inviteTabMounted,
                    stepChange: _vm.stepChange,
                  },
                })
              : _vm._e(),
            _vm.tabIndex === _vm.tabEnmu.commission
              ? _c("CommissionTab", {
                  attrs: { info: _vm.baseInfo },
                  on: {
                    "hook:mounted": _vm.commissionTabMounted,
                    stepChange: _vm.stepChange,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.rootNewGuyGuide.show
        ? _c("div", { staticStyle: { width: "100%", height: "400px" } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }